import React from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Grid,
  Header,
  Icon,
  Segment
} from "semantic-ui-react";
import "./dashboard.styles.scss";

type MenuItem = {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  url: string;
};

// Menu items based on admin.layout.tsx
const menuItems: MenuItem[] = [
  {
    icon: <Icon name="chart bar" size="large" />,
    title: "Захиалгууд",
    subtitle: "Захиалгын тайлан болон статистик",
    url: "/mongol/report/orders",
  },
  {
    icon: <Icon name="truck" size="large" />,
    title: "Хүргэлт",
    subtitle: "Хүргэлтийн тайлан болон статистик",
    url: "/mongol/report/delivery",
  },
  {
    icon: <Icon name="shipping fast" size="large" />,
    title: "Papa хүргэлт",
    subtitle: "Papa хүргэлтийн төлөв шалгах",
    url: "/mongol/report/papa-deliveries",
  },
  {
    icon: <Icon name="dollar sign" size="large" />,
    title: "Орлого",
    subtitle: "Орлогын тайлан болон статистик",
    url: "/mongol/report/payments",
  },
  {
    icon: <Icon name="chart bar" size="large" />,
    title: "Захиалгын тайлан",
    subtitle: "Захиалгын тайлан болон статистик",
    url: "/mongol/report/ordersbi",
  },
  {
    icon: <Icon name="box" size="large" />,
    title: "Бүтээгдэхүүн",
    subtitle: "Бүтээгдэхүүний жагсаалт болон шинэ бүтээгдэхүүн нэмэх",
    url: "/mongol/products",
  },
  {
    icon: <Icon name="barcode" size="large" />,
    title: "Баркод",
    subtitle: "Бар кодоор барааны үлдэгдэл нэмэх",
    url: "/mongol/shelf",
  },
  {
    icon: <Icon name="warehouse" size="large" />,
    title: "Нийлүүлэгч",
    subtitle: "Нийлүүлэгчдийн жагсаалт болон шинэ нийлүүлэгч нэмэх",
    url: "/mongol/providers",
  },
  {
    icon: <Icon name="user" size="large" />,
    title: "Нийлүүлэгч ажилтан",
    subtitle: "Нийлүүлэгчдийн ажилтнуудын мэдээлэл",
    url: "/mongol/provider-users",
  },
  {
    icon: <Icon name="tag" size="large" />,
    title: "Брэнд",
    subtitle: "Брэндийн жагсаалт болон шинэ брэнд нэмэх",
    url: "/mongol/brands",
  },
  {
    icon: <Icon name="folder" size="large" />,
    title: "Категори",
    subtitle: "Категорийн жагсаалт болон шинэ категори нэмэх",
    url: "/mongol/categories",
  },
  {
    icon: <Icon name="users" size="large" />,
    title: "Хэрэглэгч",
    subtitle: "Худалдан авагчдын мэдээлэл",
    url: "/mongol/clients",
  },
  {
    icon: <Icon name="building" size="large" />,
    title: "Байгууллага",
    subtitle: "Байгууллагуудын жагсаалт болон шинэ байгууллага нэмэх",
    url: "/mongol/companies",
  },
  {
    icon: <Icon name="image" size="large" />,
    title: "Баннер",
    subtitle: "Баннерын жагсаалт болон шинэ баннер нэмэх",
    url: "/mongol/banners",
  },
  {
    icon: <Icon name="star" size="large" />,
    title: "Онцлох Контент",
    subtitle: "Онцлох контентийн жагсаалт болон шинэ контент нэмэх",
    url: "/mongol/contents",
  },
  {
    icon: <Icon name="calendar times" size="large" />,
    title: "Хүргэлтгүй өдрүүд",
    subtitle: "Хүргэлтгүй өдрүүдийн тохиргоо",
    url: "/mongol/dayoff",
  },
  {
    icon: <Icon name="cog" size="large" />,
    title: "Веб сайтын тохиргоо",
    subtitle: "Веб сайтын тохиргооны мэдээлэл",
    url: "/mongol/settings",
  }
]

class Dashboard extends React.Component {
  render() {
    return (
      <Container className='dashboard-page'>
        <Segment basic className='dashboard-header'>
          <Header as='h1' className='dashboard-header-title'>
            Chef Professional
          </Header>
        </Segment>
        <Grid columns={3} stackable className='dashboard-sections'>
          {menuItems.map((section, idx) => (
            <Grid.Column key={idx}>
              <Link to={section.url} style={{ textDecoration: 'none' }}>
                <Segment className='dashboard-section' textAlign='center' style={{ cursor: 'pointer' }}>
                  <div className='dashboard-section-icon'>
                    {section.icon}
                  </div>
                  <Header className='dashboard-section-title'>
                    {section.title}
                  </Header>
                  <div className='dashboard-section-subtitle'>
                    {section.subtitle}
                  </div>
                </Segment>
              </Link>
            </Grid.Column>
          ))}
        </Grid>
      </Container>
    );
  }
}

export default Dashboard;
